import { Routes } from '@angular/router';
import { WebsiteComponent } from './layout/website/website.component';

import { DashboardComponent } from './layout/dashboard/dashboard.component';
import { AuthGuard } from '@auth/guards/auth.guard';

export const routes: Routes = [
    // 1. Authenticated SaaS App (Dashboard Shell)
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('@core/core.routes').then((m) => m.CORE_ROUTES),
                data: { title: 'Dashboard' },
            },
            {
                path: 'experience',
                loadChildren: () =>
                    import('@experience/experience-cloud.routes').then(
                        (m) => m.EXPERIENCE_CLOUD_ROUTES,
                    ),
                data: { title: 'Experience' },
            },
            {
                path: 'media',
                loadChildren: () =>
                    import('./media-cloud/media-cloud.routes').then((m) => m.MEDIA_CLOUD_ROUTES),
                data: { title: 'Media' },
            },
            {
                path: 'identity',
                loadChildren: () =>
                    import('./identity-cloud/identity-cloud.routes').then(
                        (m) => m.IDENTITY_CLOUD_ROUTES,
                    ),
                data: { title: 'Identity' },
            },
        ],
    },

    // 2. Public Website (Website Shell)
    {
        path: '',
        component: WebsiteComponent,
        loadChildren: () => import('@website/website.routes').then((m) => m.WEBSITE_ROUTES),
        data: { title: 'Dashboard' },
    },

    // 3. Fallback Route
    { path: '**', redirectTo: '' },
];
